import React from "react";
import { validatePartnerRoleType } from "../../utils/common/index";
import DashboardFilter from "../../containers/dashboardFilter";
import { useSelector } from "react-redux";
import Alert from "../../components/alert";
import { hideAlertActivation } from "../../redux/actions/activationSales";

const ActivationSalesView = ({ salesData, timestampArr, dashboardName }) => {
  const {
    getAllAPI,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    partnerRoleType,
    shouldRun,
  } = useSelector((state) => state.homeReducer);
  const { showAlert } = useSelector((state) => state.activationSalesReducer);

  return (
    <div className="container-fluid">
      {partnerRoleType &&
      validatePartnerRoleType(partnerRoleType).showFilters ? (
        <DashboardFilter dashboard={dashboardName} />
      ) : null}
      <h2
        className="pagetitle wow fadeInUp"
        data-wow-delay=".5s"
        data-wow-duration="0.7s"
      >
        Sim Activation
      </h2>
      <Alert showAlert={showAlert} hideAlert={hideAlertActivation} />
      {shouldRun ? (
        salesData({
          getAllAPI,
          filterValue,
          headerSelectedDateFrom,
          headerSelectedDateTo,
          timestampArr,
        })
      ) : (
        <div
          className="whitebox wow fadeInUp text-center disclaimer p-4 rounded"
          data-wow-delay=".6s"
          data-wow-duration="0.7s"
        >
          <ul>
            <li>{window.CLICK_RUN_1}</li>
            {partnerRoleType &&
            validatePartnerRoleType(partnerRoleType).showFilters ? (
              <li>{window.CLICK_RUN_2}</li>
            ) : null}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ActivationSalesView;
